import React from "react";
import { OptimizelyLinkCollection } from "../../types/optimizely/blocks";

interface LinkListBlockProps {
    name: string;
    links: OptimizelyLinkCollection;
}

const LinkListBlock = (props: LinkListBlockProps) => {
    const { name, links } = props;

    return (
        <div>
            <p>{name}</p>
            {links.value.map(link => (
                <p><a className="text-[16px] font-bold text-primary underline" href={link.href}>{link.text}</a></p>
            ))}
        </div>
    );
}

export default LinkListBlock;